import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import GemstoneCard from "../components/GemstoneCard";
import { useAuth } from "../context/AuthContext";
import { useWishlist } from "../context/WishlistContext";
import Seo from "../components/Seo";

const Wishlist = () => {
  const { user } = useAuth();
  const wl = useWishlist();
  const [items, setItems] = useState(null);

  useEffect(() => {
    const ids = wl?.ids || [];
    if (user && user !== false) {
      api.get("/wishlist").then(({ data }) => setItems(data));
      return;
    }
    if (!ids.length) { setItems([]); return; }
    Promise.all(ids.map((id) => api.get(`/gemstones/${id}`).then((r) => r.data).catch(() => null)))
      .then((arr) => setItems(arr.filter(Boolean)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, wl?.ids?.length]);

  return (
    <div data-testid="wishlist-page" className="pt-32">
      <Seo title="Wishlist" description="Saved gemstones from OPIKJEWELS." path="/wishlist" noIndex />
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-12">
        <div className="flex items-center gap-3 mb-5">
          <Heart size={14} className="text-gold" />
          <p className="font-accent text-[11px] tracking-[0.28em] uppercase text-gold">Saved Pieces</p>
        </div>
        <h1 className="font-heading font-light text-5xl md:text-7xl leading-[1.05]">Your wishlist.</h1>
        {!(user && user !== false) && <p className="mt-6 text-white/50 max-w-xl">Saved on this device. <Link to="/login" className="text-gold hover:text-ivory">Sign in</Link> to sync across devices.</p>}
      </section>
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-32">
        {items === null && <div className="text-white/40">Loading…</div>}
        {items && items.length === 0 && (
          <div className="text-white/50">
            No pieces saved yet. <Link to="/collection" className="text-gold hover:text-ivory">Browse the collection.</Link>
          </div>
        )}
        {items && items.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((g) => <GemstoneCard key={g.id} gem={g} />)}
          </div>
        )}
      </section>
    </div>
  );
};

export default Wishlist;
